import { UIText1 } from '@cian/ui-kit';
import { IRooms } from '../../containers/RoomsList/types';
import * as styles from './RoomsList.css';

interface IRoomsListProps {
  rooms: IRooms[];
}

export function RoomsList({ rooms }: IRoomsListProps) {
  return (
    <ul className={styles['rooms']}>
      {rooms.map((room, index) => {
        return (
          <li className={styles['rooms__item']} key={index}>
            <UIText1>{room.roomsCount}</UIText1>
            <UIText1 fontWeight="bold">{room.minPrice}</UIText1>
          </li>
        );
      })}
    </ul>
  );
}
